import { ProjectDto } from '@/core';
import { ProjectsConstructorNavMenu } from './ProjectsConstructorNavMenu';
import classNames from 'classnames';
import classes from './MobileStepper.module.scss';

type MobileStepperPropsType = {
  isActive: boolean;
  projectData: ProjectDto;
  closeStepper: () => void;
};

export const MobileStepper = ({ closeStepper, projectData, isActive }: MobileStepperPropsType) => {
  return (
    <div className={classNames(classes.mobileStepper, isActive && classes.active)} onClick={closeStepper}>
      <div
        className={classNames(classes.mobileStepper__content, isActive && classes.active)}
        onClick={(e) => e.stopPropagation()}
      >
        <ProjectsConstructorNavMenu projectData={projectData} />
      </div>
    </div>
  );
};
